import dayjs from 'dayjs';
import { Response } from '@/types/wellbeing-response';

export const compareWellbeingResponsesByTimeDesc = (
  a: Response,
  b: Response,
): number => (dayjs(b.sendTimeStamp).isBefore(dayjs(a.sendTimeStamp)) ? -1 : 1);
